import { BsTrash } from 'react-icons/bs'
import { TextArea } from 'components/TextArea'
import { ActionPlanTableBodyProps, QuestionsTypes } from "../helpers"
import { observationTextAreaStyles, trashComponent } from '../styles'
export default function ActionPlanTableRow({
    index,
    register,
    control,
    handleDelete,
    setFocusedInputData,
    errors,
    setValue,
    disabledForRole,
    isStaticData,
    trigger
}: ActionPlanTableBodyProps) {
    const hasError = (index: number, inputName: QuestionsTypes) => {
        const doesHas = errors.fields?.[index]?.[inputName]
        return !!doesHas
    }
    const disabledBgColor = disabledForRole ? 'bg-[#F6F6F6]' : ''
    const disabledIcon = disabledForRole
        ? 'text-mediumGray cursor-default'
        : 'cursor-pointer'
    const getErrorColor = (hasError: boolean) => {
        return hasError ? 'outline outline-2 outline-[#C43B5180]' : ''
    }
    const adjustHeight = (e) => {
        const textareaValue = e.target.value;
        const textarea = e.target;
        textarea.style.height = `40px`;
        if (textareaValue) {
            let scHeight = e.target.scrollHeight
            textarea.style.height = `${scHeight}px`;
      
        }
    }
    const handleChange = (event, index) => {
        let result = event.target.value.replace(/[^0-9]/gi, '');
        if (!result) {
            setValue(`fields.${index}.how_much`, 'R$ ' + '0,00');
        } else {
            result = Number.parseInt(result) + ''
            if (result.length === 1) {
                result = '0,0' + result
            } else if (result.length === 2) {
                result = '0,' + result
            } else {
                result = result.substring(0, result.length - 2) + ',' + result.substring(result.length - 2)
            }
            setValue(`fields.${index}.how_much`, 'R$ ' + result,{shouldDirty:true});
        }
    };
    const handleTime = (prompt: string) => {
        // Remove non-digit characters
        let formattedValue = prompt.replace(/\D/g, '');
        // Format to dd/mm/yyyy
        if (formattedValue.length > 2) {
            formattedValue = formattedValue.replace(/^(\d{2})/, '$1/');
        }
        if (formattedValue.length > 5) {
            formattedValue = formattedValue.replace(/^(\d{2})\/(\d{2})/, '$1/$2/');
        }
        // Trim excess characters
        formattedValue = formattedValue.slice(0, 10);
        setValue(`fields.${index}.when`, formattedValue,{shouldDirty:true});
    }
    return (
        <tr className="divide-x-2 relative" data-testid="test-action-table-body">
            <td
                className={`
                h-[185px]
               ${disabledBgColor} `}
            >
                    
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    required={true}
                    maxLength={400}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].what`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} ${getErrorColor(hasError(index, `what`))} `}
                    placeholder="Digite aqui"
                    rows={18}
                />
            </td>
            <td
                className={`
               ${disabledBgColor}`}
            >
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    required={true}
                    maxLength={400}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].why`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} text-xs ${getErrorColor(hasError(index, `why`))}`}
                    placeholder="Digite aqui"
                    rows={8}
                />
            </td>

            <td
                className={`
               ${disabledBgColor}`}
            >
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    required={true}
                    maxLength={400}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].where`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} ${getErrorColor(hasError(index, `where`))}`}
                    placeholder="Digite aqui"
                    rows={8}
                />
            </td>
            <td
                className={`
               ${disabledBgColor}`}
            >
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    required={true}
                    maxLength={400}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].when`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} ${getErrorColor(
                        hasError(index, `who`)
                    )} h-10`}
                    onChange={(e) => {
                        handleTime(e.target.value)
                    }}
                    placeholder="xx/xx/xxxx"
                    rows={8}
                />


            </td>
            <td
                className={` ${disabledBgColor}`}
            >
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    required={true}
                    maxLength={400}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].who`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} ${getErrorColor(
                        hasError(index, `who`)
                    )}`}
                    placeholder="Digite aqui"
                    rows={8}
                />
            </td>
            <td
                className={` ${disabledBgColor}`}
            >
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    required={true}
                    maxLength={400}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].how`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} ${getErrorColor(
                        hasError(index, `how`)
                    )}`}
                    placeholder="Digite aqui"
                    rows={8}
                />
            </td>
            <td
                className={`
                 ${disabledBgColor}
              `}
            >
                <TextArea
                    onKeyUp={adjustHeight}
                    disabled={disabledForRole}
                    onChange={(event) => handleChange(event, index)}
                    noBorder={true}
                    defaultValue={''}
                    name={`fields[${index}].how_much`}
                    register={register}
                    className={`${observationTextAreaStyles} text-xs ${disabledBgColor} ${getErrorColor(hasError(index, `how_much`))}`}
                    placeholder="Digite aqui"
                    rows={8}
                />
                {
                    !isStaticData ?
                        <BsTrash
                            data-testid="test-delete-action-trash"
                            onClick={() => {
                                !disabledForRole && handleDelete(index)
                            }}
                            className={`${trashComponent} ${disabledIcon}`}
                            size={24}
                        /> : null
                }
            </td>
        </tr>
    )
}
